import React from "react";
import { Filter, Loading, ToggleSwitch } from "../";

interface Props {
    onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
    onClick: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
    onClear: (event: React.MouseEvent<SVGSVGElement, MouseEvent>) => void;
    isActive: boolean;
    showDropdown: boolean;
    options: string[];
    isLoading: boolean;
    value: string[];
}

export const ExpertAreasFilter: React.FC<Props> = ({
    onChange,
    onClick,
    onClear,
    isActive,
    showDropdown,
    options,
    isLoading,
    value,
}) => {
    return (
        <Filter
            isActive={isActive}
            showDropdown={showDropdown}
            onClear={onClear}
            onClick={onClick}
            text="STRUČNO PODRUČJE"
        >
            {isLoading ? (
                <Loading />
            ) : (
                options.map(option => (
                    <div key={option}>
                        <ToggleSwitch
                            value={option}
                            checked={Boolean(value.includes(option))}
                            onChange={onChange}
                            htmlFor={option}
                            text={<div className="filter__item__text">{option}</div>}
                        />
                    </div>
                ))
            )}
        </Filter>
    );
};
